<div class="content" [formGroup]="formGroup">
  <mat-radio-group
    class="link-account-radio-group"
    formControlName="enrollment"
    (change)="onChangeEnrollment($event)">
    <mat-radio-button
      *ngFor="let enrollment of enrollments"
      class="radio-button enrollment-list-item"
      [value]="enrollment"
      aria-label="{{
        'accessibility.redeem_cash_v2.checkout.enrollment_option'
          | translate
            : {
                product: productType(enrollment),
                digits: enrollment.groupReferenceId.toString().substr(-4)
              }
      }}">
      <p aria-hidden="true" class="enrollment-product-type">
        {{ productType(enrollment) }}
      </p>
      <p aria-hidden="true" class="enrollment-group-reference-id">
        {{ displayedAccountNumber(enrollment.groupReferenceId) }}
      </p>
    </mat-radio-button>
    <mat-radio-button
      *ngIf="shouldAllowRedeemToOtherAccount"
      class="radio-button enrollment-list-item">
      <p class="enrollment-product-type">
        {{ 'redeem_cash_v2.link_account_form.title' | translate }}
      </p>
    </mat-radio-button>
  </mat-radio-group>
</div>
